import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    MIC_HUB_PAGE_LOADING() {
      return {
        isLoading: true,
        micHubPage: action.micHubPage
      };
    },
    MIC_HUB_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'mic-hub-page',
        'categoryPage'
      );

      return {
        isLoading: false,
        data: action.micHubPage,
        ads: adModelData
      };
    },
    MIC_HUB_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micHubPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
